module.exports = __webpack_public_path__ + "static/media/compra-segura.47327301.png";